import { apiFetch } from '../services/httpClient';

async function http(path, options = {}) {
  // Add timeout to prevent hanging on cold starts
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), 30000); // 30 second timeout

  try {
    const resp = await apiFetch(path, {
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
      signal: controller.signal,
      ...options,
    });
    
    clearTimeout(timeoutId);
    
    if (!resp.ok) {
      const msg = await resp.text();
      const err = new Error(`${resp.status} ${resp.statusText}: ${msg}`);
      err.status = resp.status;
      throw err;
    }
    if (resp.status === 204) return null;
    return resp.json();
  } catch (error) {
    clearTimeout(timeoutId);
    if (error.name === 'AbortError') {
      throw new Error('Request timed out - server may be starting up');
    }
    throw error;
  }
}

export const auth = {
  login: ({ email = null, phone = null, password, captcha_token = null }) =>
    http('/auth/login', { method: 'POST', body: JSON.stringify({ email, phone, password, captcha_token }) }),
  
  signup: ({ email = null, phone = null, first_name = null, last_name = null, password, captcha_token = null }) =>
    http('/auth/signup', { method: 'POST', body: JSON.stringify({ email, phone, first_name, last_name, password, captcha_token }) }),
  
  me: () => http('/auth/me', { method: 'GET' }),
  
  // Returns { ok: true, exp: <number> }
  refresh: () => http('/auth/refresh', { method: 'POST' }),
  
  logout: () => http('/auth/logout', { method: 'POST' }),
};
